export const utils = {
    formatDateTime: (isoDate: string) => {
        const dateObj = new Date(isoDate);

        // Month names
        const monthNames = [
            "January", "February", "March", "April", "May", "June", "July", "August",
            "September", "October", "November", "December"
        ];

        // Get parts of the date
        const month = monthNames[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();

        // Format day with ordinal suffix (e.g., 1st, 2nd, 3rd, etc.)
        const dayWithSuffix = (day: number) => {
            const j = day % 10,
                k = day % 100;
            if (j === 1 && k !== 11) return day + "st";
            if (j === 2 && k !== 12) return day + "nd";
            if (j === 3 && k !== 13) return day + "rd";
            return day + "th";
        };

        // Format time (12-hour format with AM/PM)
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        const period = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format

        // Zero-pad minutes if necessary
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedDate = `${month} ${dayWithSuffix(day)}, ${year}`;
        const formattedTime = `${formattedHours}:${formattedMinutes} ${period}`;

        return { formattedDate, formattedTime };
    },

    getDeviceStyles: (styles: { phone: {}; tablet: {}; desktop: {}; }, deviceWidth: number) => {
        let deviceStyles = {};

        if (deviceWidth <= 600) {
            deviceStyles = styles.phone;
        } else if (deviceWidth <= 1024) {
            deviceStyles = styles.tablet;
        } else {
            deviceStyles = styles.desktop;
        }

        return deviceStyles;
    },
    
    htmlToWhatsappFriendlyText: (html: string) => {
        const replacements = [
            { regex: /<strong>(.*?)<\/strong>/gi, replace: '*$1*' },
            { regex: /<b>(.*?)<\/b>/gi, replace: '*$1*' },
            { regex: /<em>(.*?)<\/em>/gi, replace: '_$1_' },
            { regex: /<i>(.*?)<\/i>/gi, replace: '_$1_' },
            { regex: /<li>(.*?)<\/li>/gi, replace: '•$1\n' },
            { regex: /<ul>|<\/ul>|<ol>|<\/ol>/gi, replace: '' },
            { regex: /<br\s*\/?>/gi, replace: '\n' },
            { regex: /(&nbsp;)+/gi, replace: '\n' }, // multiple or single &nbsp;
            { regex: /<p>(.*?)<\/p>/gi, replace: '$1\n\n' },
            { regex: /<\/?[^>]+(>|$)/gi, replace: '' }, // strip any remaining tags
        ];

        let text = html;

        for (const { regex, replace } of replacements) {
            text = text.replace(regex, replace);
        }

        // Trim and normalize multiple blank lines to max two
        return text.replace(/\n{3,}/g, '\n\n').trim();
    }
}